import * as addToBagConfig from '@nuxt-common/add-to-bag/config.bcom';
export * as babyRegistryConfig from './app/config/baby-registry-bcom';
export * from '@nuxt-common/add-to-bag/config.bcom.js';
export * from '@nuxt-common/login-component/config.bcom.js';
export * from '@nuxt-common/locator/config.bcom.js';
export * from '@nuxt-common/creditcard-banner-consumable/config.bcom';
export const brand = 'bcom';

export const offers = addToBagConfig.offers; // add to bag offers

export const errorMessages = {
  registrySettings: 'There was an error loading the page. Please try again.',
  rgistrySettingApiErrorDefault: 'Something went wrong, try again.',
  giftGiverView: 'Looks like we’re experiencing some technical difficulties. Please try again.',
  giftTracker: 'There was an error loading the page. Please try again.',
  registrantBenefitsTab: 'There was an error loading the page. Please try again.',
  myGiftTab: 'There was an error loading the page. Please try again.',
  productDetailsDrawer: 'The server was unable to process your request. Please try again.',
  serverProcessingError: 'The server was unable to process your request. Please try again.',
  removeItemError: 'Something went wrong. Please try to remove the item again.',
  somethingWentWrongError: 'Something didn’t quite work',
  searchRegistryError: 'There was an error loading the page. Please try again or search a different name.',
  giftTrackerApiError: 'The server was unable to process your request. Please try again',

  addToBagError: 'The server was unable to load your information. Please try again',
  registrantItemSaveChangesError: 'Something went wrong. Please try again',
  registrantHomeTabError: 'The server was unable to process your request. Please try again.',
  canvasError: 'The server was unable to process your request. Please try again.',
  locationError: 'The server was unable to load your information. Please try again',
  createYourRegistryError: 'Something went wrong. Please try again',
  searchError: 'Something went wrong. Please try again',
  createYourRegistryBackendError:
    "Oops! There's a temporary issue with this page.It's a quick fix if you want to wait, or feel free to continue shopping and come back here afterward. CONTINUE SHOPPING",
  giftCardOptionsUpdateError: 'Something went wrong.',
  registryManageDeactivatedError: 'Registry has been deleted due to inactivity. Please call an associate for more detail ',
};

export const suggestedCategoryList = [
  {
    name: 'Get Inspired',
    url: '/shop/wedding-registry/registry-ideas?id=1038159',
    imagePath: 'bcom_Get_Inspired.png',
  },
  {
    name: 'Dining & Entertaining',
    url: '/shop/home/dining-entertaining?id=1000244',
    imagePath: 'bcom_Dining_Entertaining.webp',
  },
  {
    name: 'Kitchen',
    url: '/shop/home/kitchen?id=1000245',
    imagePath: 'bcom_Kitchen.webp',
  },
  {
    name: 'Home Decor',
    url: '/shop/home/home-decor?id=1001539',
    imagePath: 'bcom_Home_Decor.webp',
  },
  {
    name: 'Bedding & Bath',
    url: '/shop/all-home/Home_product_type/Bath%7CBedding?id=1003615',
    imagePath: 'bcom_Bed_Bath.webp',
  },
];

export const allSuggestedCategoryList = [
  {
    name: 'Dining & Serveware',
    url: '/shop/home/dining-entertaining?id=1000244',
  },
  {
    name: 'Bar & Wine Accessories',
    url: '/shop/home/cocktail-beer-wine-accessories-bar-tools?id=1054659',
  },
  {
    name: 'Kitchen',
    url: '/shop/home/kitchen?id=1000245',
  },
  {
    name: 'Home Decor',
    url: '/shop/home/home-decor?id=1001539',
  },
  {
    name: 'Bed & Bath',
    url: '/shop/all-home/Home_product_type/Bath%7CBedding?id=1003615',
  },
  {
    name: 'Luggage',
    url: '/shop/home/luggage-travel?id=1005589',
  },
  {
    name: 'Cleaning & Organizing',
    url: '/shop/home/housekeeping-home-electronics?id=1042859',
  },
  {
    name: 'Furniture',
    url: '/shop/home/furniture-mattresses?id=1006362',
  },
];

export const createRegistryStep1 = {
  header: 'CONGRATS ON YOUR ENGAGEMENT',
  subHeader: 'Let’s do this!',
  imgUrlDesktop: 'Bloomingdales_Wedding_Registry_Create a Registry_Step1_WEB.webp',
  imgUrlMobile: 'Bloomingdales_Wedding_Registry_Create a Registry_Step1_MEW.webp',
  yourName: 'Your name',
  yourFirstName: 'First name',
  yourLastName: 'Last name',
  partnersName: "Partner's name",
  partnersFirstName: 'First name',
  partnersLastName: 'Last name',
  zipCode: 'Zip code',
  eventLabel: 'When is your event?',
  addressLabel: 'Where would you like us to send your registry gifts?',
};

export const createRegistryStep2 = {
  consultantHeader: 'GET ONE-ON-ONE GUIDANCE',
  consultantSubHeader: 'Our dedicated Registry Consultants are here to help, every step of the way.',
  consultantPreferredStorePrompt: { header: 'Connect with an expert at:    ', subHeader: ' Select your preferred store ' },
  consultantBoxNoStore: {
    header: 'No store nearby',
    subHeader: 'We’ll still connect you with one of our Registry Consultants to help you virtually',
  },
  preferencesPrivacyPromptTooltip:
    "<span class='medium' style='color:white'>Public or private registry view</span><br><br/>We offer two views for your registry — Public & Private:<br><br>When set to <span class='medium' style='color:white'>Private</span>, your registry can only be viewed by you. Choose this option if you’re not yet ready to share your registry publicly with guests.<br><br> When set to <span class='medium' style='color:white'>Public</span>, your guests can view your registry and make purchases from it. Your registration is shared with and viewable at The Knot and its affiliate sites and optimized for internet searches for your special event. Choose this option when you’re ready to share your registry.<br><br><i>You can change your preference at any time.</i><br><br> <a style='color:white' href='https://www.bloomingdales.com/customer-service/articles/highlights-of-bloomingdales-notice-of-privacy-practices/' style='color:white'>Notice of Privacy Practices</a>",
  preferencesCheckboxEmails: [
    {
      label: 'I’d like to receive emails about exciting events, helpful tools, and take advantage of my exclusive registry offers',
      value: 'true',
    },
  ],
  termsAndConditions:
    "By continuing, you agree to Bloomingdale's <a href='https://www.bloomingdales.com/customer-service/articles/bloomingdales-and-bloomingdalescom-notice-of-privacy-practices#HowWeCollectInformation'>Privacy Practices.</a>",
  imgUrlDesktop: 'Bloomingdales_Wedding_Registry_Create a Registry_Step2_WEB.webp',
  imgUrlMobile: 'Bloomingdales_Wedding_Registry_Create a Registry_Step2_MEW.webp',
  consultantPreferenceText: 'PREFERENCES',
  registryEmail: 'Registry emails',
  contactPreferenceLabel: 'How would you prefer your consultant to contact you?',
};

export const WeddingLandingPage = {
  Header: 'WEDDING REGISTRY',
  Subheader: 'An unparalleled selection of amazing gifts.',
  CreateSubheader: '',
  CreateValueProp1: 'Exclusive perks like 20% off dresses & suiting',
  CreateValueProp2: 'Registry Concierges to help every step of the way',
  CreateValueProp3: '20% off completion offers & more',
  CreateCTA: 'GET STARTED',
  FindSubheader: '',
  FindCTA: 'SEARCH',
  linkRegistryCTA: 'Start here',
  linkRegistryLargeCTA: 'Start here',
  imagePathDesktop: 'Bloomingdales_Wedding_Registry_HP_Image_WEB.webp',
  imagePathMobile: 'Bloomingdales_Wedding_Registry_HP_Image_MEW.webp',
  imagePathNewWeddingDesktop: 'Bloomingdales_Registry_Entry_Desktop_Wedding.webp',
  imagePathNewWeddingMobile: 'Bloomingdales_Registry_Entry_MEW_Wedding.webp',
  placeholderNewWeddingDesktop:
    'data:image/webp;base64,UklGRooAAABXRUJQVlA4IH4AAAAwBQCdASogABoAPxF2tFAsJ6UisBgMAYAiCWcAvzgPX8lX7IEwmyEsfoQ1fUvnqRaaAADv4twiNYXCbIyVveY/xouUwCuepg/n/bCNmXkyUapFHvL5g1doLNs3IiABTCx6JSpAyIAMxQdpp9hh1Z+dD/KPVYjDnGc2W4dEAAA=',
  placeholderNewWeddingMobile:
    'data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAAAQBQCdASogABoAPwVwsVArpqUisAwBcCCJZQC7ACBz1VFO6XRhrlas3WGfNfJCgdFAAPn7YcUfdmy+sQ48misZm9FI1RFnRXcBzq5OdMMX72sZIIPu52rICa6cGlu3cZ/Zi9BQ7kUzOlhw60/QNPDB+Np1bI9TLcuP1qgA',
  placeholderDesktop:
    'data:image/webp;base64,UklGRlgAAABXRUJQVlA4IEwAAACQAwCdASogAA0ALtGIxGIkLCwsDADQS0gABc6a619WIuloXZgAAP619xjmLl/jRLqF+TpHkzDRfWjM/Yyvtc+lBIjMHDRO2tLA4AAA',
  placeholderMobile:
    'data:image/webp;base64,UklGRqYAAABXRUJQVlA4IJoAAACQBwCdASogAFUAPu1op1AppqOivVdIATAdiWcACG+rwK2QCbndE53Uv6WlgToaBM/2OvbFe2szsL0lVVV6zCctg2SClMAA/vAPv+Ny2bCe5//KDx8OE9PMfiycmeuPPeXlLLzIbJoaNTZVCFpekBbJs88Uuxh5zcw7yaiEDKZQY061qAKSy1n4GaXMiqk2TyNdJJ/dkCGgAAAA',
  signInCTA: 'Sign in',
  getStartedCTA: 'Get started',
};

export const BabyLandingPage = {
  Header: 'little baby registry',
  Subheader: '',
  CreateSubheader: '',
  CreateValueProp1: '20% off maternity clothes and fine jewelry',
  CreateValueProp2: 'Baby registry experts to help every step of the way',
  CreateValueProp3: '20% off completion offer & more exclusive perks',
  CreateCTA: 'GET STARTED',
  FindSubheader: '',
  linkRegistryCTA: 'Start here',
  imagePathNewBabyDesktop: 'Bloomingdales_Registry_Entry_Desktop_Baby.webp',
  imagePathNewBabyMobile: 'Bloomingdales_Registry_Entry_MEW_Baby.webp',
  placeholderNewBabyDesktop:
    'data:image/webp;base64,UklGRoAAAABXRUJQVlA4IHQAAABwBQCdASogABoAPwForVArJaSit/qoAWAgCWUAtDQYr0AK6jiFO82SUe5FMauEyAb3JwAAAP6/aCXtW7vtm73p8moA5911xJHwl2WDANeRGD5NB7oQePb5ooVLG6Yeb0xAPuiSyVEkhHdw3dl+Zr9qCMAAAA==',
  placeholderNewBabyMobile:
    'data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAACQBQCdASogABoAPxF4sFAsJ6SisBgMAYAiCWUAwNwMOK/c9xocbK3/qvnm88IXLuvc8TLQQAD+OJusOLfVlWP6RIdXmYMhDcbgtTpPUslB2ZXxIA6bpOepMyIt3oGmXSN8RyGyF/HZucTXGQCQp8uBVwAAAA==',
  imagePathDesktopBaby: 'Bloomingdales_Baby_Registry_Registry_HP_Image_WEB.webp',
  imagePathMobileBaby: 'Bloomingdales_Baby_Registry_HP_Image_MEW.webp',
  placeholderDesktopBaby:
    'data:image/webp;base64,UklGRlQAAABXRUJQVlA4IEgAAABQAwCdASogAA0APxFwsFAsJiSisAgBgCIJQBOgBaD5C2rlAAD+4aHD4zb1INBwACIweWATMzmkyDNERjwLB9A3S5uLlR+miAA=',
  placeholderMobileBaby:
    'data:image/webp;base64,UklGRqIAAABXRUJQVlA4IJYAAACQBwCdASogAFUAPvleolAqpKMit/xtUVAfCWdrlVpkliwJfxD29Cj0c9VSGEQA2jaBcStwKsz3I/CK7DJvbQzgXjQ6GEAA/talOM0E9pwcgnqEMsgU5JSbnucgShdL4xcX1TUfCnezK0LEbxwtfMmC5XLUGXdBtH1+JF1iWbb6PZMQFqhRisEEgDF/FMIRzYLVgMkJQAA=',
  signInCTA: 'Sign in',
  getStartedCTA: 'Get started',
};

export const giftGiverRegistryView = {
  sortBy: { recentlyAdded: 'Recently added', priceLowToHigh: 'Price (low-high)', priceHighToLow: 'Price (high-low)' },
  barcodeInstructions: 'Show this barcode to one of our Registry Concierges for<br>assistance in store.',
  brandHeaderText: 'The Registry',
  backToRegistry: 'BACK TO REGISTRY',
  noItemsError: 'There are no items on this registry <i>yet.</i>',
  infiniteScrollExpId: '1109-21',
  bagDirectWeddingRegistryBrand: '',
  bagDirectBabyRegistryBrand: '',
  bagWeddingRegistryBrand: 'WEDDING REGISTRY',
  bagBabyRegistryBrand: 'BABY REGISTRY',
};

export const registrantProductCard = {
  addToBagButtonText: 'ADD TO BAG',
  purchasedButtonText: 'Fulfilled',
  purchasedBadgeText: 'Purchased',
  discontinuedOutOfStockButtonText: 'Discontinued',
  discontinuedOutOfStockBadgeText: 'Discontinued',
  discontinuedInStockBadgeText: 'Limited-time availability',
  outOfStockOnlineAllChannelButtonText: 'Call To Order',
  outOfStockOnlineAllChannelBadgeText: 'Call 212-705-2023 to order.',
  outOfStockOnlineAllChannelBadgeLink:
    'Call <a href="#" onclick="event.preventDefault(); event.stopPropagation(); document.location.href=\'tel:+1-212-705-2023\';">212-705-2023</a> to order.',
  inStoreBopsBossButtonText: 'Call To Order',
  inStoreBopsBossInfoText: 'Call 212-705-2023 to order.',
  inStoreBopsBossInfoLink:
    'Call <a href="#" onclick="event.preventDefault(); document.location.href=\'tel:+1-212-705-2023\';" class="in-store-call-link">212-705-2023</a> to order.',
  backorderedBadgeText: 'On order',
  lowInStockInfoText: 'Low stock',
  bigTicketItem: "Not available online. Call '800‑568‑8865' for availability",
  bigTicketItemLink:
    'Not available online. Call \'<a href="#" onclick="event.preventDefault(); document.location.href=\'tel:+1-800-568-8865\';" class="in-store-call-link">800‑568‑8865</a>\' for availability',
  specialOrder: 'Special Order',
  moreLikeThisCTA: 'More like this',
  purchasedText: 'purchased',
};

export const quickViewSlideOut = {
  myGiftsDetailsSave: 'SAVE CHANGES',
  myGiftsDetailsRemoveItem: 'REMOVE',
  myGiftsDetailsATB: 'ADD TO BAG',
};

export const giftGiverProductCard = {
  addToBagButtonText: 'ADD TO BAG',
  purchasedButtonText: 'Fulfilled',
  purchasedBadgeText: 'Purchased',
  discontinuedInStockInfoText: 'Limited-time availability',
  outOfStockOnlineAllChannelButtonText: 'CALL TO ORDER',
  outOfStockOnlineAllChannelBadgeText: 'Call 212-705-2023 to order.',
  outOfStockOnlineAllChannelBadgeLink:
    'Call <a href="#" onclick="event.preventDefault(); event.stopPropagation(); document.location.href=\'tel:+1-212-705-2023\';">212-705-2023</a> to order.',
  inStoreBopsBossButtonText: 'CALL TO ORDER',
  inStoreBopsBossInfoText: 'Call 212-705-2023 to order.',
  inStoreBopsBossInfoLink:
    'Call <a href="#" onclick="event.preventDefault(); document.location.href=\'tel:+1-212-705-2023\';" class="in-store-call-link">212-705-2023</a> to order.',
  backorderedInfoText: 'On order',
  lowInStockInfoText: 'Low stock',
  bigTicketItem: "Not available online. Call '800‑568‑8865' for availability",
  bigTicketItemLink:
    'Not available online. Call \'<a href="#" onclick="event.preventDefault(); document.location.href=\'tel:+1-800-568-8865\';" class="in-store-call-link">800‑568‑8865</a>\' for availability',
  specialOrder: 'Special Order',
  giftCardImageUrl: 'Bloomingdale-Gift-Card.webp',
};

export const dreamFundProductCard = {
  dreamFundThumbnailImg: 'Dream_Fund_Thumbnail',
};

export const shareRegitsry = {
  privacyTooltip:
    '<span class="medium" style="color:white">Public or private registry view</span><br/><br/> We offer two views for your registry — Public & Private: <br/><br/> When set to <span class="medium" style="color:white">Private</span>, your registry can only be viewed by you. Choose this option if you’re not yet ready to share your registry publicly with guests. <br/><br/>When set to <span class="medium" style="color:white">Public</span>, your guests can view your registry and make purchases from it. Your registration is shared with and viewable at The Knot and its affiliate sites and optimized for internet searches for your special event. Choose this option when you’re ready to share your registry.<br/><br/><i>You can change your preference at any time.</i><br/><br/> <a style="color:white" href="https://www.bloomingdales.com/customer-service/app/answers/detail/a_id/357?_ga=2.99738206.1545408833.1667415981-636262068.1667415981">Notice of Privacy Practices</a>',
  shareLink: 'Share this link with friends & family!',
  shareEmailInstructions: 'Thank you so much for being a part of our big day! Check out our wedding registry at Bloomingdale’s.',
  weddingRegistryText: 'wedding registry',
};

export const findRegistry = {
  subheader: '',
  findRegistryTitle: 'Going to a wedding? Give a gift they’ll remember for years to come.',
  findRegistryCTA: 'Find a registry',
};

export const searchRegistryResult = {
  name: 'NAME',
  occasionType: 'REGISTRY TYPE',
  formattedOccasionDate: 'DATE',
  searchRegistryText: 'Search by name or registry ID',
  searchRegistryFullText: 'Search by full name or registry ID',
};

export const manageRegistry = {
  headerContactConsultant: 'Contact your registry concierge',
  tabMyGifts: 'Registry',
  tabGiftsTracker: 'Gift tracker',
  giftCalculatorTileHeader: 'How many gifts should I register for?',
  giftCalculatorTileHeaderTooltip:
    'We suggest adding 2 gifts for every guest (double your total invite list) so there are plenty of options to choose from.',
  giftCalculatorTileSomeGifts: 'The excitement is building!',
  giftCalculatorTileSubHeader: 'Add the estimated number of guests you’re inviting.',
  giftCalculatorTileInitialStage: 'We’ll help calculate the recommended number of gifts based on how many guests you’re inviting.',
  consultantTileHeader: 'GET ONE-ON-ONE GUIDANCE',
  consultantTileBody: 'Our dedicated Registry Concierges are here to help, every step of the way.',
  consultantTileSecondaryCTA: 'BOOK AN APPOINTMENT',
  consultantTileTitle: 'YOUR REGISTRY CONCIERGE',
  myGiftsNoItems: 'Looks like your registry is empty! Start adding items you love',
  myGiftsNoItemsGiftCard: ', or if you’re still deciding ',
  myGiftsNoItemsGiftCardAdd: 'register for gift cards',
  myGiftsCategoryCarouselHeader: 'NEED SUGGESTIONS?',
  myGiftsDetailsRemoveItem: 'REMOVE',
  completionBannerHeader: 'DIDN’T GET EVERYTHING ON YOUR REGISTRY?',
  completionBannerPrint: 'PRINT',
  completionBannerCTA: 'SEE OFFER DETAILS',
  completionBcomBannerSaveText: 'Save 20%',
  completionBcomBannerSubHeader: 'on almost all remaining items for six months after your event date.',
  completionBannerSubHeader: 'Save 20% on almost all remaining items for six months after your event date.',
  completionBannerImageWeddingDesktop: 'Bloomingdales_Wedding_Registry_Completion_Ad_WEB_1440.webp',
  completionBannerImageWeddingMobile: 'Bloomingdales_Wedding_Registry_Completion_Ad_MEW.webp',
  completionBannerImageBabyDesktop: 'Bloomingdales_Baby_Registry_Completion_Ad_WEB.webp',
  completionBannerImageBabyMobile: 'Bloomingdales_Baby_Registry_Completion_Ad_MEW.webp',
  popularRegisteredItemsHeader: 'POPULAR REGISTRY GIFTS',
  completionModalHeader: 'YOUR COMPLETION OFFER',
  completionModalSubHeader: 'Save 20% on almost all remaining items for six months after your event date.',
  completionModalOnlineHeader: 'Online',
  completionModalOnlineBodyFirstPhrase: 'Use promo code',
  completionModalOnlineBodySecondPhrase: 'at checkout',
  completionModalInStoreHeader: 'In Store',
  completionModalInStoreBody: 'Show this barcode to an associate',
  preOccasionMedalliaFormId: 12490,
  postOccasionMedalliaFormId: 12491,
  headerProfileIconWedding: 'Bloomingdales_Wedding_Registry_Default_Thumbnail_WEB_MEW.webp',
  headerProfileIconBaby: 'Bloomingdales_Baby_Registry_Default_Thumbnail_WEB_MEW.webp',
  surveyRibbon: 'PROVIDE FEEDBACK',
  surveyCopyCTA: {
    title: 'Give feedback & help improve the registry',
    link: 'Answer a few questions',
    subtitle: ' how we can improve your experience.',
  },
  giftTrackerNoContentMessage: 'When gifts are purchased from your registry, you’ll see them displayed here.',
  myGiftsNoCategoryText1: 'There’s nothing from this category on your registry yet. To see items you’re registered for, adjust your filters.',
  myGiftsNoCategoryText2: 'Explore',
  myGiftsNoCategoryText3: '.',
  myGiftsConjunction: ' and ',
  giftCalculatorTilePrimaryCTA: 'ADD MORE GIFTS',
  shareRegistryTitle: 'SHARE YOUR REGISTRY',
  starterIdeasLink: '/shop/wedding-registry/home/getting-started?id=1001499&cm_sp=NAVIGATION_REG-_-TOP_NAV-_-GETTING-STARTED-n-n',
  babyStarterIdeasLink: '/shop/registry/shop-all-registry-items/Age_category/Infant?id=1224372',
  daysAwayText: 'Days away',
  giftsPurchased: 'Gifts purchased',
  giftsAdded: 'Gifts added',
  barcodeInstructionsMyGifts: 'Show this barcode to an associate',
  registryPrivacyInfoMessage: 'When you’re ready, set your registry as public to share it with family and friends.',
  eGiftCardUpcNumber: 478000234587,
  pGiftCardUpcNumber: 478000244609,
  registryGiftCardTileHeader1: 'NEW! REGISTER FOR GIFT CARDS',
  registryGiftCardTileHeader2: "YOU'RE REGISTERED FOR GIFTS CARDS",
  registryGiftCardTileQuestion: 'Get exactly what you want',
  registryGiftCardBody1: 'Bloomingdale’s Gift Cards give you the flexibility to buy the things you need once you’re ready.',
  registryGiftCardBody2: 'Your loved ones can choose the amount.',
  registryGiftCardTextCTA1: 'Add to registry',
  registryGiftCardTextCTA2: 'Edit options',
  giftCardCheckboxValue: 'Register for Bloomingdale’s gift cards',
  registryPostCompletionMessage:
    'You can no longer add new items to this registry, but you may still delete or purchase any items you like. To request additional gifts,',
  guestCountTileLabel: 'Number of guests',
  guestStateTileHeader: 'How many gifts should I register for?',
  giftCalculatorRecommendedGift: 'Recommended amount of gifts for',
  giftCardGiftsSuggested: 'gifts suggested',
  giftTrackerSortByValues: [
    {
      value: 'sortByDate_asc',
      displayValue: 'First purchased',
    },
    {
      value: 'sortByDate_desc',
      displayValue: 'Most recently purchased',
    },
    {
      value: 'sortByName_asc',
      displayValue: 'Gifter’s name (A–Z)',
    },
    {
      value: 'sortByName_desc',
      displayValue: 'Gifter’s name (Z–A)',
    },
  ],
  giftTrackerGiftReceivedActionValues: [
    {
      label: 'Gift received',
      value: 'giftReceived',
    },
  ],
  giftTrackerThankyouSentActionValues: [
    {
      label: 'Thank you sent',
      value: 'thankyouSent',
    },
  ],
  giftsAddedText: 'PSA: You can always add more!',
  bagDirectWeddingRegistryBrand: '',
  bagDirectBabyRegistryBrand: '',
  bagWeddingRegistryBrand: 'WEDDING REGISTRY',
  bagBabyRegistryBrand: 'BABY REGISTRY',
  backToRegistry: 'BACK TO REGISTRY',
};

export const registrySettingsText = {
  registryEmailsCheckbox: [
    {
      label: 'Email me about exciting events, helpful tools, and exclusive registry offers.',
      value: true,
    },
  ],
  privacyPreferenceOptions: [
    {
      label: 'Public',
      value: 'Public',
    },
    {
      label: 'Private',
      value: 'Private',
    },
  ],
  currentShippingAddress: 'Current shipping address',
  contactInformation: 'Contact information',
  eventDetails: 'Event details',
  shippingAddress: 'Shipping address',
  giftCards: 'Gift cards',
  guestCountLabel: 'Number of guests:',
  eventLabel: 'Event:',
  visibilityStatusLabel: 'Visibilty status',
  giftCardsRegisteredLabel: 'Registered for gift cards:',
  receiveGiftCardsLabel: 'Receive gift cards by:',
  guestCountTileHeader: 'Number of guests',
};

export const linkRegistryText = {
  linkTooltip:
    "We offer two views for your registry — Public & Private: <br/><br/> When set to <span class='medium'>Private</span>, your registry can only be viewed by you. Choose this option if you’re not yet ready to share your registry publicly with guests. <br/> <br/>When set to <span class='medium'>Public</span>, your guests can view your registry and make purchases from it. Your registration is shared with and viewable at The Knot and its affiliate sites and optimized for internet searches for your special event. Choose this option when you’re ready to share your registry. <br/></br><i>You can change your preference at any time. </i><br/> <br/><a href='https://www.bloomingdales.com/customer-service/articles/bloomingdales-and-bloomingdalescom-notice-of-privacy-practices'>Notice of Privacy Practices</a>",
  linkCta: 'CONTINUE',
  makeThisPublicText: 'Make this public',
  whatsThis: 'What’s this?',
  toolTipTitle: 'Public or private registry view',
};

export const giftCardSlideOut = {
  myGiftsDetailsATB: 'ADD TO BAG',
};

export const giftCardProductCard = {
  brand: 'Bloomingdale’s',
  imageUrl:
    'https://images.bloomingdalesassets.com/is/image/BLM/products/9/optimized/10939829_fpx.tif?qlt=85,0&resMode=sharp2&op_usm=1.75,0.3,2,0&fmt=jpg&wid=302&hei=378',
  registrantInfo: 'Starting at $10',
  giftGiverInfo: 'Starting at $10',
  registrantCTA: 'Edit',
  giftGiverCTA: 'Add To Bag',
};

export const registryBonusGifts = [
  {
    image: 'all_clad.webp',
    title: 'ALL-CLAD',
    text: { COMPLETE: '$500 or more of All-Clad', GET: 'a Cook & Serve Tool Set' },
    pdf: 'https://allcladgift.registriaqa.com/',
    analyticsName: 'All-Clad',
  },
  {
    image: 'all_clad.webp',
    title: 'ALL-CLAD',
    text: { COMPLETE: '$800 or more of All-Clad', GET: 'a HA1 Nonstick 10" Frypan & Cook & Serve Tool Set' },
    pdf: 'https://allcladgift.registriaqa.com/',
    analyticsName: 'All-Clad',
  },
  {
    image: 'baccarat.webp',
    title: 'BACCARAT',
    text: { COMPLETE: '$2,000 or more of Baccarat', GET: 'a Mille Nuits Decanter Stand' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2023BaccaratRedemptionForm.pdf',
    analyticsName: 'Baccarat',
  },
  {
    image: 'Christofle_GWC.webp',
    title: 'CHRISTOFLE',
    text: { COMPLETE: '$3,000 or more of Christofle', GET: 'a Constellation Vase with Silver Charm' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2020ChristofleGiftWithCompletionForm.pdf',
    analyticsName: 'Christofle',
  },
  {
    image: 'cusinart.webp',
    title: 'CUISINART',
    text: { COMPLETE: '$400 or more of Cuisinart', GET: 'a set of 3 Multi-Color Mixing Bowls' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2022CuisinartGiftWithCompletion.pdf',
    analyticsName: 'Cuisinart',
  },
  {
    image: 'GeorgJensen.webp',
    title: 'GEORG JENSEN',
    text: { COMPLETE: '$1,200 or more of Georg Jensen', GET: 'a medium Bloom Tall Bowl' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2024GeorgJensenGiftwithCompletion.pdf',
    analyticsName: 'Georg Jensen',
  },
  {
    image: 'Hestan.webp',
    title: 'HESTAN',
    text: { COMPLETE: '$1,000 or more of Hestan', GET: 'a ProBond™ TITUM Nonstick 11" Skillet' },
    pdf: 'https://hestanculinary.com/pages/registry',
    analyticsName: 'Hestan',
  },
  {
    image: 'juliska.webp',
    title: 'JULISKA',
    text: { COMPLETE: '$1,200 or more of Juliska', GET: 'a Berry & Thread Ceramic Serving Bowl' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2020JuliskaGiftWithCompletionForm.pdf',
    analyticsName: 'Juliska',
  },
  {
    image: 'Kate_Spade.webp',
    title: 'KATE SPADE NEW YORK',
    text: { COMPLETE: '$500 or more of kate spade new york', GET: 'a South Street 5"x7" gold wavy frame' },
    pdf: 'https://www.lenox.com/pages/ksny-wedding-registry-gift',
    analyticsName: 'Kate Spade',
  },
  {
    image: 'Le_Creuset_GWC_500.webp',
    title: 'LE CREUSET',
    text: { COMPLETE: '$500 or more of Le Creuset', GET: 'a Toughened Nonstick Pro 11" Crepe Pan with Rateau' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2024LeCreusetRegistryGiftwithCompletion.pdf',
    analyticsName: 'Le Creuset',
  },
  {
    image: 'Le_Creuset_GWC_1500.webp',
    title: 'LE CREUSET',
    text: {
      COMPLETE: '$1,500 or more of Le Creuset',
      GET: 'a Toughened Nonstick Pro 11" Crepe Pan with Rateau & 5 qt. Signature Enameled Cast Iron Wok with Glass Lid in Cerise',
    },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2024LeCreusetRegistryGiftwithCompletion.pdf',
    analyticsName: 'Le Creuset',
  },
  {
    image: 'Lenox.webp',
    title: 'LENOX',
    text: { COMPLETE: '$500 or more of Lenox', GET: 'a Lenox Tuscany Classics 5 Piece Decanter and Glass Set' },
    pdf: 'https://www.lenox.com/pages/wedding-registry-gift',
    analyticsName: 'Lenox',
  },
  {
    image: 'MackenzieChilds.webp',
    title: 'MACKENZIE-CHILDS',
    text: { COMPLETE: '$1,000 or more of MacKenzie-Childs', GET: 'a Medium Courtly Check Casserole' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2023Mackenzie-ChildsRedemptionForm.pdf',
    analyticsName: 'Mackenzie Child',
  },
  {
    image: 'Matouk_GWC.webp',
    title: 'MATOUK',
    text: { COMPLETE: '$500 or more of Matouk', GET: 'a set of two Auberge hand towels' },
    pdf: 'https://www.matouk.com/bloomingdales-registry',
    analyticsName: 'Matouk',
  },
  {
    image: 'MichaelAram_2023.webp',
    title: 'MICHAEL ARAM',
    text: { COMPLETE: '$995 or more of Michael Aram', GET: 'a White Orchid Small Vase' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2023MichaelAramRedemptionForm.pdf',
    analyticsName: 'Michael Aram',
  },
  {
    image: 'nambe.webp',
    title: 'NAMBE',
    text: { COMPLETE: '$500 or more of Nambe', GET: 'a 5"x7" Dazzle Frame' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2024NambeGiftWithCompletion.pdf',
    analyticsName: 'Nambe',
  },
  {
    image: 'nambe1000.webp',
    title: 'NAMBE',
    text: { COMPLETE: '$1,000 or more of Nambe', GET: 'a 5"x7" Dazzle Frame & Dazzle 2 piece Dessert Set' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2024NambeGiftWithCompletion.pdf',
    analyticsName: 'Nambe',
  },
  {
    image: 'nespresso.webp',
    title: 'NESPRESSO',
    text: { COMPLETE: '$199 or more of Nespresso', GET: 'a $50 credit on your Nespresso account' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2024NespressoGiftwithCompletion.pdf',
    analyticsName: 'Nespresso',
  },
  {
    image: 'Orreffors.webp',
    title: 'ORREFORS',
    text: { COMPLETE: '$500 or more of Orrefors', GET: '2 small heart votives/bowls' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2024OrreforsGiftwithCompletion.pdf',
    analyticsName: 'Orrefors',
  },
  {
    image: 'Reed_and_Barton.webp',
    title: 'REED & BARTON',
    text: { COMPLETE: '$500 or more of Reed & Barton', GET: 'a Lydon Silverplate 4"x6" photo frame' },
    pdf: 'https://www.reedandbarton.com/pages/wedding-registry-gift',
    analyticsName: 'Reed & Barton',
  },
  {
    image: 'shun.webp',
    title: 'SHUN',
    text: { COMPLETE: '$450 or more of Shun', GET: 'a Shun knife' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2024ShunGiftWithCompletion.pdf',
    analyticsName: 'Shun',
  },
  {
    image: 'tumi_gwc.webp',
    title: 'TUMI',
    text: { COMPLETE: '$1,000 or more of Tumi', GET: 'a "Just In Case" Tote Bag' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2021TumiGiftWithCompletionForm.pdf',
    analyticsName: 'Tumi',
  },
  {
    image: 'vietri.webp',
    title: 'VIETRI',
    text: { COMPLETE: '$1,000 or more of VIETRI', GET: '2 Natalia Champagne Glasses' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2024VietriGiftwithCompletion.pdf',
    analyticsName: 'Vietri',
  },
  {
    image: 'Vitamix_Book.webp',
    title: 'VITAMIX',
    text: { COMPLETE: 'any full-size Vitamix blender under $399', GET: 'the three cookbook set' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2024VitamixGiftwithCompletion.pdf',
    analyticsName: 'Vitamix',
  },
  {
    image: 'Vitamix_Container.webp',
    title: 'VITAMIX',
    text: { COMPLETE: 'any Vitamix blender $399 and up', GET: 'an Aer Disc container' },
    pdf: 'https://netstorage.bloomingdales.com/netstorage/media/gifts-with-completion/current/2024VitamixGiftwithCompletion.pdf',
    analyticsName: 'Vitamix',
  },
];

export const BAG_WEDDING_REGISTRY_BRAND = 'WEDDING REGISTRY';
export const BAG_BABY_REGISTRY_BRAND = 'BABY REGISTRY';

// eslint-disable-next-line import/no-mutable-exports
export let REGISTRY_FOR = BAG_WEDDING_REGISTRY_BRAND;
export const setRegistryFor = (isBaby) => {
  REGISTRY_FOR = isBaby ? BAG_BABY_REGISTRY_BRAND : BAG_WEDDING_REGISTRY_BRAND;
};
